"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestEventType = exports.FileType = exports.OperatorActionType = exports.ModerationTargetType = exports.DetectedIntent = exports.CategorySlug = exports.NotificationType = exports.NotificationChannel = exports.NotificationStatus = exports.ModerationStatus = exports.ReviewStatus = exports.ResponseStatus = exports.SelectedMode = exports.BudgetType = exports.UrgencyLevel = exports.RequestStatus = exports.RequestSource = exports.VerificationStatus = exports.VerificationType = exports.ClientVerificationLevel = exports.ProviderVerificationLevel = exports.AvailabilityStatus = exports.Role = exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "active";
    UserStatus["Suspended"] = "suspended";
    UserStatus["Deleted"] = "deleted";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var Role;
(function (Role) {
    Role["Client"] = "client";
    Role["Handyman"] = "handyman";
    Role["Operator"] = "operator";
    Role["Admin"] = "admin";
})(Role || (exports.Role = Role = {}));
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["Available"] = "available";
    AvailabilityStatus["Busy"] = "busy";
    AvailabilityStatus["Offline"] = "offline";
    AvailabilityStatus["OnVacation"] = "on_vacation";
})(AvailabilityStatus || (exports.AvailabilityStatus = AvailabilityStatus = {}));
var ProviderVerificationLevel;
(function (ProviderVerificationLevel) {
    ProviderVerificationLevel["Unverified"] = "unverified";
    ProviderVerificationLevel["IdentityVerified"] = "identity_verified";
    ProviderVerificationLevel["ProVerified"] = "pro_verified";
    ProviderVerificationLevel["TrustedPro"] = "trusted_pro";
})(ProviderVerificationLevel || (exports.ProviderVerificationLevel = ProviderVerificationLevel = {}));
var ClientVerificationLevel;
(function (ClientVerificationLevel) {
    ClientVerificationLevel["Unverified"] = "unverified";
    ClientVerificationLevel["Verified"] = "verified";
    ClientVerificationLevel["Trusted"] = "trusted";
})(ClientVerificationLevel || (exports.ClientVerificationLevel = ClientVerificationLevel = {}));
var VerificationType;
(function (VerificationType) {
    VerificationType["Identity"] = "identity";
    VerificationType["Professional"] = "professional";
})(VerificationType || (exports.VerificationType = VerificationType = {}));
var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus["Pending"] = "pending";
    VerificationStatus["Approved"] = "approved";
    VerificationStatus["Rejected"] = "rejected";
    VerificationStatus["Cancelled"] = "cancelled";
})(VerificationStatus || (exports.VerificationStatus = VerificationStatus = {}));
var RequestSource;
(function (RequestSource) {
    RequestSource["Miniapp"] = "miniapp";
    RequestSource["Bot"] = "bot";
    RequestSource["Api"] = "api";
})(RequestSource || (exports.RequestSource = RequestSource = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["Draft"] = "draft";
    RequestStatus["Pending"] = "pending";
    RequestStatus["Matching"] = "matching";
    RequestStatus["Assigned"] = "assigned";
    RequestStatus["InProgress"] = "in_progress";
    RequestStatus["Completed"] = "completed";
    RequestStatus["Cancelled"] = "cancelled";
    RequestStatus["Expired"] = "expired";
})(RequestStatus || (exports.RequestStatus = RequestStatus = {}));
var UrgencyLevel;
(function (UrgencyLevel) {
    UrgencyLevel["Flexible"] = "flexible";
    UrgencyLevel["Today"] = "today";
    UrgencyLevel["Urgent"] = "urgent";
})(UrgencyLevel || (exports.UrgencyLevel = UrgencyLevel = {}));
var BudgetType;
(function (BudgetType) {
    BudgetType["None"] = "none";
    BudgetType["Fixed"] = "fixed";
    BudgetType["Range"] = "range";
    BudgetType["Hourly"] = "hourly";
})(BudgetType || (exports.BudgetType = BudgetType = {}));
var SelectedMode;
(function (SelectedMode) {
    SelectedMode["Browse"] = "browse";
    SelectedMode["Broadcast"] = "broadcast";
    SelectedMode["Operator"] = "operator";
})(SelectedMode || (exports.SelectedMode = SelectedMode = {}));
var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["Pending"] = "pending";
    ResponseStatus["Accepted"] = "accepted";
    ResponseStatus["Declined"] = "declined";
    ResponseStatus["Expired"] = "expired";
    ResponseStatus["Withdrawn"] = "withdrawn";
})(ResponseStatus || (exports.ResponseStatus = ResponseStatus = {}));
var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["Published"] = "published";
    ReviewStatus["Hidden"] = "hidden";
    ReviewStatus["Flagged"] = "flagged";
})(ReviewStatus || (exports.ReviewStatus = ReviewStatus = {}));
var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["Open"] = "open";
    ModerationStatus["Resolved"] = "resolved";
    ModerationStatus["Dismissed"] = "dismissed";
})(ModerationStatus || (exports.ModerationStatus = ModerationStatus = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["Pending"] = "pending";
    NotificationStatus["Sent"] = "sent";
    NotificationStatus["Failed"] = "failed";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["Telegram"] = "telegram";
    NotificationChannel["Email"] = "email";
    NotificationChannel["Push"] = "push";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["NewLead"] = "new_lead";
    NotificationType["LeadAccepted"] = "lead_accepted";
    NotificationType["LeadDeclined"] = "lead_declined";
    NotificationType["AssignmentCreated"] = "assignment_created";
    NotificationType["JobCompleted"] = "job_completed";
    NotificationType["ReviewReceived"] = "review_received";
    NotificationType["VerificationApproved"] = "verification_approved";
    NotificationType["VerificationRejected"] = "verification_rejected";
    NotificationType["SystemMessage"] = "system_message";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var CategorySlug;
(function (CategorySlug) {
    CategorySlug["Plumber"] = "plumber";
    CategorySlug["Electrician"] = "electrician";
    CategorySlug["ApplianceRepair"] = "appliance_repair";
    CategorySlug["Cleaning"] = "cleaning";
    CategorySlug["Moving"] = "moving";
    CategorySlug["Taxi"] = "taxi";
    CategorySlug["Other"] = "other";
})(CategorySlug || (exports.CategorySlug = CategorySlug = {}));
var DetectedIntent;
(function (DetectedIntent) {
    DetectedIntent["ServiceRequest"] = "service_request";
    DetectedIntent["HandymanRegistration"] = "handyman_registration";
    DetectedIntent["ClientRegistration"] = "client_registration";
    DetectedIntent["Support"] = "support";
    DetectedIntent["Unknown"] = "unknown";
})(DetectedIntent || (exports.DetectedIntent = DetectedIntent = {}));
var ModerationTargetType;
(function (ModerationTargetType) {
    ModerationTargetType["User"] = "user";
    ModerationTargetType["Review"] = "review";
    ModerationTargetType["Request"] = "request";
    ModerationTargetType["PortfolioCase"] = "portfolio_case";
})(ModerationTargetType || (exports.ModerationTargetType = ModerationTargetType = {}));
var OperatorActionType;
(function (OperatorActionType) {
    OperatorActionType["AssignProvider"] = "assign_provider";
    OperatorActionType["SuspendUser"] = "suspend_user";
    OperatorActionType["RestoreUser"] = "restore_user";
    OperatorActionType["ApproveVerification"] = "approve_verification";
    OperatorActionType["RejectVerification"] = "reject_verification";
    OperatorActionType["HideReview"] = "hide_review";
    OperatorActionType["UnhideReview"] = "unhide_review";
    OperatorActionType["OverrideCategory"] = "override_category";
    OperatorActionType["RebroadcastRequest"] = "rebroadcast_request";
    OperatorActionType["ResolveModerationFlag"] = "resolve_moderation_flag";
})(OperatorActionType || (exports.OperatorActionType = OperatorActionType = {}));
var FileType;
(function (FileType) {
    FileType["Image"] = "image";
    FileType["Document"] = "document";
    FileType["Video"] = "video";
})(FileType || (exports.FileType = FileType = {}));
var RequestEventType;
(function (RequestEventType) {
    RequestEventType["Created"] = "created";
    RequestEventType["CategoryDetected"] = "category_detected";
    RequestEventType["ModeSelected"] = "mode_selected";
    RequestEventType["LeadBroadcast"] = "lead_broadcast";
    RequestEventType["ProviderSelected"] = "provider_selected";
    RequestEventType["Assigned"] = "assigned";
    RequestEventType["Accepted"] = "accepted";
    RequestEventType["Arrived"] = "arrived";
    RequestEventType["Completed"] = "completed";
    RequestEventType["Cancelled"] = "cancelled";
    RequestEventType["OperatorOverride"] = "operator_override";
})(RequestEventType || (exports.RequestEventType = RequestEventType = {}));
//# sourceMappingURL=enums.js.map